import { ejsonStringify } from '@racemap/sdk/schema/base';
import { HTTPFetchError } from '../api-client';
import fetch from '../fetch';

export function downloadBlob(blob: Blob, filename: string): void {
  if (document == null || window == null)
    throw new Error('Function works only in browser context.');

  const link = document.createElement('a');
  link.href = window.URL.createObjectURL(blob);
  link.download = filename;

  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(link.href);
}

export function downloadAsEJson(exportObj: unknown, exportName: string) {
  const blob = new Blob([ejsonStringify(exportObj, undefined, 2)], { type: 'application/json' });
  downloadBlob(blob, `${exportName}.json`);
}

export async function downloadFile(url: string, filename?: string) {
  const response = await fetch(url);

  if (!response.ok) {
    const error = await HTTPFetchError.from(response.status, response, url, 'GET');
    throw error;
  }

  const contentDisposition = response.headers.get('Content-Disposition');
  // search for filename or filename* in the Content-Disposition header
  const filenameMatch = contentDisposition?.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);

  const encodedVersion = decodeURI(
    filenameMatch
      ?.find((match) => match.includes('filename*'))
      ?.replace(/filename\*=/, '')
      .replace("UTF-8''", '') || '',
  );
  const simpleVersion = decodeURI(
    filenameMatch
      ?.find((match) => !match.includes('filename*'))
      ?.replace('filename=', '')
      ?.replace(/"/g, '') || '',
  );
  const blob = await response.blob(); // Get the file as a Blob
  const urlBlob = URL.createObjectURL(blob); // Create a URL for the Blob

  const a = document.createElement('a');
  a.href = urlBlob;
  a.download = filename || encodedVersion || simpleVersion || 'file';
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(urlBlob);
}
